
// @ts-nocheck


export const localeCodes =  [
  "en",
  "fr",
  "de",
  "nl",
  "pl",
  "es",
  "it",
  "he",
  "pt"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_45US_46ts_ae74704f",
      load: () => import("#nuxt-i18n/ae74704f" /* webpackChunkName: "locale_en_45US_46ts_ae74704f" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_45FR_46ts_dcd147b7",
      load: () => import("#nuxt-i18n/dcd147b7" /* webpackChunkName: "locale_fr_45FR_46ts_dcd147b7" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_45DE_46ts_b8e8b646",
      load: () => import("#nuxt-i18n/b8e8b646" /* webpackChunkName: "locale_de_45DE_46ts_b8e8b646" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_45NL_46ts_a7f7e4c2",
      load: () => import("#nuxt-i18n/a7f7e4c2" /* webpackChunkName: "locale_nl_45NL_46ts_a7f7e4c2" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_45PL_46ts_02a220cd",
      load: () => import("#nuxt-i18n/02a220cd" /* webpackChunkName: "locale_pl_45PL_46ts_02a220cd" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_45ES_46ts_c72093e6",
      load: () => import("#nuxt-i18n/c72093e6" /* webpackChunkName: "locale_es_45ES_46ts_c72093e6" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_45IT_46ts_fd48f99d",
      load: () => import("#nuxt-i18n/fd48f99d" /* webpackChunkName: "locale_it_45IT_46ts_fd48f99d" */),
      cache: true
    }
  ],
  he: [
    {
      key: "locale_he_45IL_46ts_debfb9c7",
      load: () => import("#nuxt-i18n/debfb9c7" /* webpackChunkName: "locale_he_45IL_46ts_debfb9c7" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_45PT_46ts_ff959a3f",
      load: () => import("#nuxt-i18n/ff959a3f" /* webpackChunkName: "locale_pt_45PT_46ts_ff959a3f" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/9bec0e7d" /* webpackChunkName: "config_i18n_46config_46ts_9bec0e7d" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      files: [
        "/opt/build/repo/i18n/locales/en-US.ts"
      ]
    },
    {
      code: "fr",
      name: "Français",
      files: [
        "/opt/build/repo/i18n/locales/fr-FR.ts"
      ]
    },
    {
      code: "de",
      name: "Deutsch",
      files: [
        "/opt/build/repo/i18n/locales/de-DE.ts"
      ]
    },
    {
      code: "nl",
      name: "Nederlands",
      files: [
        "/opt/build/repo/i18n/locales/nl-NL.ts"
      ]
    },
    {
      code: "pl",
      name: "Polski",
      files: [
        "/opt/build/repo/i18n/locales/pl-PL.ts"
      ]
    },
    {
      code: "es",
      name: "Español",
      files: [
        "/opt/build/repo/i18n/locales/es-ES.ts"
      ]
    },
    {
      code: "it",
      name: "Italien",
      files: [
        "/opt/build/repo/i18n/locales/it-IT.ts"
      ]
    },
    {
      code: "he",
      name: "Hebrew",
      files: [
        "/opt/build/repo/i18n/locales/he-IL.ts"
      ]
    },
    {
      code: "pt",
      name: "Português",
      files: [
        "/opt/build/repo/i18n/locales/pt-PT.ts"
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: true,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/opt/build/repo/i18n/locales/en-US.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    files: [
      {
        path: "/opt/build/repo/i18n/locales/fr-FR.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutsch",
    files: [
      {
        path: "/opt/build/repo/i18n/locales/de-DE.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    name: "Nederlands",
    files: [
      {
        path: "/opt/build/repo/i18n/locales/nl-NL.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    name: "Polski",
    files: [
      {
        path: "/opt/build/repo/i18n/locales/pl-PL.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Español",
    files: [
      {
        path: "/opt/build/repo/i18n/locales/es-ES.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    name: "Italien",
    files: [
      {
        path: "/opt/build/repo/i18n/locales/it-IT.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "he",
    name: "Hebrew",
    files: [
      {
        path: "/opt/build/repo/i18n/locales/he-IL.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    name: "Português",
    files: [
      {
        path: "/opt/build/repo/i18n/locales/pt-PT.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/